export default {"src":"/_next/static/media/Kansas.2f74ecf6.svg","height":322,"width":800,"blurWidth":0,"blurHeight":0};